function findShortcodeByCodePoint(emojiCodePoint) {
  // Find the emoji by code point
  const emojiIcon = emojiLists.find((emoji) => emoji.codes === emojiCodePoint);
  // console.log(emojiIcon);
  if (emojiIcon) {
    // Extract the shortcode from emojiDictionary if available
    const shortcode = window.emojiDictionary.getName(emojiIcon.character);

    if (shortcode) {
      return shortcode;
    } else {
      // If no shortcode is available, generate one from the Unicode name
      const unicodeNameParts = emojiIcon.name.split(' ');
      const generatedShortcode = unicodeNameParts.join('_');
      return generatedShortcode;
    }
  } else {
    return null; // Handle the case when the emoji is not found
  }
}
function findEmojiByCode(code) {
  console.log('code: ' + code);
  if (!code) {
    return;
  }
  if (code && code.length === 1) {
    return code;
  }
  return emojiLists.find((emoji) => emoji.codes === code)?.char;
}
